var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['o-feed-section-loading', _vm.$store.getters.getIsClientData === false
    ? 'o-feed-section-loading-upgrade' : '']},[_c('MoleculeFeedSectionLoading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }